import { isNotNil } from 'app/lib/fp/isNotNil.js';
import { isNotEmpty } from 'app/lib/fp/isEmpty.js';
import { allPass } from 'app/lib/fp/allPass.js';

export const isNotNilOrEmpty = allPass([isNotNil, isNotEmpty]);
